/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminStockItem
 */
export interface OutputAdminStockItem {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    cameraType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    connectionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    id?: number;
    /**
     * Атрибути дрона (null для боєкомплекту)
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    missionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    opticDistanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    totalOnPositions?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    type?: string;
    /**
     * Атрибути боєкомплекту (null для дрона)
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    warheadType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    weightKg?: number;
}

/**
 * Check if a given object implements the OutputAdminStockItem interface.
 */
export function instanceOfOutputAdminStockItem(value: object): boolean {
    return true;
}

export function OutputAdminStockItemFromJSON(json: any): OutputAdminStockItem {
    return OutputAdminStockItemFromJSONTyped(json, false);
}

export function OutputAdminStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'cameraType': json['cameraType'] == null ? undefined : json['cameraType'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'] == null ? undefined : json['id'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'name': json['name'] == null ? undefined : json['name'],
        'opticDistanceKm': json['opticDistanceKm'] == null ? undefined : json['opticDistanceKm'],
        'totalOnPositions': json['totalOnPositions'] == null ? undefined : json['totalOnPositions'],
        'type': json['type'] == null ? undefined : json['type'],
        'warheadType': json['warheadType'] == null ? undefined : json['warheadType'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
    };
}

export function OutputAdminStockItemToJSON(value?: OutputAdminStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cameraType': value['cameraType'],
        'connectionType': value['connectionType'],
        'description': value['description'],
        'id': value['id'],
        'missionType': value['missionType'],
        'name': value['name'],
        'opticDistanceKm': value['opticDistanceKm'],
        'totalOnPositions': value['totalOnPositions'],
        'type': value['type'],
        'warheadType': value['warheadType'],
        'weightKg': value['weightKg'],
    };
}

